import { render, staticRenderFns } from "./TransactionTab.vue?vue&type=template&id=6b74caba&scoped=true&"
import script from "./TransactionTab.vue?vue&type=script&lang=js&"
export * from "./TransactionTab.vue?vue&type=script&lang=js&"
import style0 from "./TransactionTab.vue?vue&type=style&index=0&id=6b74caba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b74caba",
  null
  
)

export default component.exports